import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const LocationWrapper = styled(PhotographyWrapper)`
  position: relative; z-index: 2;
  .location-breadcrumbs { display: flex; gap: 12px; flex-wrap: wrap; align-items: center; margin-bottom: 28px; font: 600 15px/1.5 'Nunito Sans', sans-serif; color: #68758d; }
  .location-breadcrumbs a { color: #2c5bff; text-decoration: none; }
  .location-breadcrumbs a:hover { text-decoration: underline; }
  .photo-hero-image { height: 500px; }
  .location-section-intro { display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: center; margin-bottom: 32px; }
  .location-section-intro .photo-copy, .location-section-intro .photo-title { margin-bottom: 0; }
  .location-services { scroll-margin-top: 24px; }
  .location-service-grid { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 24px; }
  .location-service { border: 1px solid #e4e8ef; border-radius: 14px; overflow: hidden; display: block; color: #1b264f; text-decoration: none; background: white; transition: box-shadow .2s; }
  .location-service:hover { color: #2c5bff; text-decoration: none; box-shadow: 0 12px 30px #1b264f12; }
  .location-service-image { height: 210px; background: #f6f8fc; }
  .location-service img { display: block; width: 100%; height: 100%; object-fit: cover; }
  .location-service img.contain { object-fit: contain; padding: 18px; }
  .location-service-copy { padding: 22px; }
  .location-service h3 { color: inherit; font-size: 19px; display: flex; align-items: baseline; justify-content: space-between; gap: 12px; }
  .location-service h3 span { color: #2c5bff; }
  .location-service p { font: 400 16px/1.65 'Nunito Sans', sans-serif; color: #52617e; margin: 0; }
  #location-work .photo-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }
  #location-work .image-card img { height: 330px; }
  .location-process .photo-copy { margin-bottom: 0; }
  .location-status { min-height: 420px; }
  @media (max-width: 991px) { .photo-hero-image { height: 440px; } .location-service-image { height: 175px; } .location-service-copy { padding: 18px; } }
  @media (max-width: 767px) {
    .location-breadcrumbs { margin-bottom: 24px; font-size: 14px; }
    .photo-hero-image { height: 320px; }
    .location-section-intro { grid-template-columns: 1fr; gap: 16px; margin-bottom: 24px; }
    .location-service-grid { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; }
    .location-service-image { height: 140px; }
    .location-service-copy { padding: 16px 12px; }
    .location-service h3 { font-size: 16px; gap: 6px; }
    .location-service p { font-size: 15px; line-height: 1.6; }
    #location-work .image-card img { height: 170px; }
  }
  @media (prefers-reduced-motion: reduce) { .location-service { transition: none; } }
`;
